import I18n from '@/modules/i18n';
import Templates from '@/pages/events/templates';

import GridyIndex from '@/controllers/common/gridy_index_controller';

export default class extends GridyIndex {
  gridyOptions() {
    return {
      headers: [
        { name: I18n.t('name'), value: 'name' },
        { name: I18n.t('activerecord.models.permission.other'), value: 'permissions' },
        { name: I18n.t('action.other'), value: '' },
      ],

      sortName: 'name',
      template: Templates.roles.gridy,
    };
  }
}
